import {
  deviceName,
} from 'modules/room';
import {
  GET_HISTORY_DATA_SUCCESS,
  GET_HISTORY_DATA_ERROR,
  TOGGLE_ROOM_DETAIL_LOADING,
} from './actions';
import { CLEAR_DATA } from '../actions';

const initState = {
  error: null,
  isLoading: false,
  hasError: false,
  data: [],
};

const roomDetailReducer = (state = initState, action) => {
  // console.log('noteListReducer', state, action);

  const { type, payload } = action;
  switch (type) {
    case GET_HISTORY_DATA_SUCCESS: {
      const { data, dataType } = payload;
      let offlineValue = 0;
      switch (dataType) {
        case deviceName.heartRate:
        case deviceName.heartRateOld:
          offlineValue = -5;
          break;
        case deviceName.breath:
        case deviceName.breathOld:
          offlineValue = -1;
          break;
        default:
          break;
      }
      const dataMapped = data.reduce((acc, point) => {
        const before = new Date(point.x);
        before.setMilliseconds(before.getMilliseconds() - 1);
        const after = new Date(point.x);
        after.setMilliseconds(after.getMilliseconds() + 1);
        if (point.y === -1) {
          return [...acc,
            { x: before.toISOString(), y: null },
            { x: point.x, y: offlineValue },
            { x: after.toISOString(), y: null },
          ];
        }
        return [...acc, point];
      }, []);
      return {
        ...state,
        data: dataMapped,
        hasError: false,
        error: null,
      };
    }

    case GET_HISTORY_DATA_ERROR: {
      const { error } = payload;
      return {
        ...state,
        hasError: true,
        error,
      };
    }

    case TOGGLE_ROOM_DETAIL_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading,
      };
    }

    case CLEAR_DATA:
      return initState;

    default:
      return state;
  }
};

export default roomDetailReducer;
